import type React from "react";

import { Box } from "@similarweb/ui-components/foundations";

import {
    StyledActionButtonWrapper,
    StyledSuperAgentTextArea,
} from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/super-agent/components/SuperAgentTextarea/styles";

type Props = {
    value: string | undefined;
    placeholder?: string;
    onChange: (value: string | undefined) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    actionButton?: React.ReactNode;
    isLoading?: boolean;
    isDisabled?: boolean;
};

export const SuperAgentTextarea: React.FC<Props> = ({
    value,
    onChange,
    placeholder,
    actionButton,
    onKeyDown,
    isLoading,
    isDisabled,
}) => {
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = event.target.value;
        onChange(newValue);
    };

    const textarea = (
        <StyledSuperAgentTextArea
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            onKeyDown={(event) => {
                if (!isDisabled) {
                    onKeyDown?.(event);
                }
            }}
            hasAction={!!actionButton}
            isLoading={isLoading}
            disabled={isDisabled}
        />
    );

    if (!actionButton) {
        return textarea;
    }

    return (
        <Box position="relative">
            {textarea}
            <StyledActionButtonWrapper $isDisabled={isDisabled}>{actionButton}</StyledActionButtonWrapper>
        </Box>
    );
};
